import { MAX_FILE_SIZE } from "@/models/constant/global.constant";

export const useValidateMaximumFileSize = (size: number): boolean => {
  return size >= MAX_FILE_SIZE;
};
